/* eslint-disable no-console */
import axios from 'axios';
import data from './data/data';

const { underlyingList } = data;

const DAY = 1000 * 60 * 60 * 24;
const formatDate = (dt) => {
  const m = dt.getMonth() + 1 < 10 ? `0${dt.getMonth() + 1}` : dt.getMonth() + 1;
  const d = dt.getDate() < 10 ? `0${dt.getDate()}` : dt.getDate();

  return `${dt.getFullYear()}-${m}-${d}`;
};

const percentColors = [
  { pct: -3.5, color: { r: 210, g: 38, b: 48 } },
  { pct: 0, color: { r: 91, g: 103, b: 112 } },
  { pct: 3.3, color: { r: 132, g: 189, b: 0 } },
];

function componentToHex(c) {
  const hex = c.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
}

function getColorForPercentage(pct) {
  let i = 1;
  for (i; i < percentColors.length - 1; i += 1) {
    if (pct < percentColors[i].pct) {
      break;
    }
  }
  const lower = percentColors[i - 1];
  const upper = percentColors[i];
  const range = upper.pct - lower.pct;
  const rangePct = (pct - lower.pct) / range;
  const pctLower = 1 - rangePct;
  const pctUpper = rangePct;
  const color = {
    r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
    g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
    b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper),
  };
  // return `rgb(${[color.r, color.g, color.b].join(',')});`;
  // or output as hex if preferred
  return `#${componentToHex(color.r)}${componentToHex(color.g)}${componentToHex(
    color.b,
  )}`;
}

const API = {
  getUpcomingEvents: (underlying) =>
    axios
      .get(`${process.env.REACT_APP_DATASPAN_API_URL}/slcalendar/events`, {
        params: {
          underlying,
          start: formatDate(new Date()),
          end: formatDate(new Date(Number(new Date()) * 1 + DAY * 14)),
        },
      })
      .then((response) => response.data)
      .catch((error) => {
        console.error(error);
        window.newrelic.noticeError(error);
      }),

  getProductsFromUnderlying: (underlying) =>
    axios
      .get(`${process.env.REACT_APP_DATASPAN_API_URL}/products/`, {
        params: {
          category: underlying,
          country: (
            (window.slHeatmap && window.slHeatmap.isoCode)
            || 'en-GB'
          ).split('-')[1],
        },
      })
      .then((response) =>
        response.data.reduce((arr, b) => {
          if (arr.find((x) => x.name === b.name)) {
            return arr;
          }
          arr.push(b);
          return arr;
        }, []))
      .catch((error) => {
        console.error(error);
        window.newrelic.noticeError(error);
      }),

  getAssetClasses: () =>
    axios
      .get(`${process.env.REACT_APP_DATASPAN_API_URL}/tickers/live/`, {
        params: {
          t: underlyingList
            .filter((u) => u.ticker !== '')
            .map((u) => u.ticker)
            .join(','),
        },
      })
      .then((response) => {
        const { data: responseData } = response;
        const result = [];
        underlyingList.forEach((u) => {
          const apiData = responseData.find((x) => x.ticker === u.ticker);
          if (!apiData) {
            // return;
          }
          let ac = result.find((aux) => aux.name === u.assetClass);
          if (!ac) {
            ac = {
              name: u.assetClass,
              groups: [],
            };
            result.push(ac);
          }

          let g = ac.groups.find((aux) => aux.name === u.group);
          if (!g) {
            g = {
              name: u.group,
              underlyingList: [],
            };
            ac.groups.push(g);
          }

          const getChg = (ticker) => {
            const aux = responseData.find((x) => x.ticker === ticker);
            if (aux) {
              return {
                chg: aux.data.chg.toFixed(2),
                lastUpdated: aux.data.lastUpdated,
              };
            }
            return {
              chg: 0,
            };
          };
          g.underlyingList.push({
            ...u,
            ...getChg(u.ticker),
          });
        });

        return result;
      })
      .catch((error) => {
        console.error('axios.catch: ', error);
        window.newrelic.noticeError(error);
        return null;
      }),

  getSunburstData: (filters) =>
    axios
      .get(`${process.env.REACT_APP_DATASPAN_API_URL}/tickers/live/`, {
        params: {
          t: underlyingList
            .filter((u) => u.ticker !== '')
            .map((u) => u.ticker)
            .join(','),
        },
      })
      .then((response) => {
        const {
          data: { data: newData },
        } = response;
        const result = [];
        underlyingList.forEach((u) => {
          if (!filters[u.group]) {
            return;
          }
          let g = result.find((aux) => aux.name === u.group);
          if (!g) {
            g = {
              name: u.group,
              itemStyle: { color: '#5B6770' },
              children: [],
            };
            result.push(g);
          }

          const getChg = (ticker) => {
            const aux = newData.find((x) => x.ticker === ticker);
            if (aux) {
              return 1;
            }
            return 0;
          };
          const chg = getChg(u.ticker);
          const color = getColorForPercentage(chg);
          g.children.push({
            name: u.name,
            itemStyle: { color },
            children: [
              {
                name: `${chg} %`,
                value: 1,
                itemStyle: { color },
                label: {
                  fontFamily: '"Avenir", sans-serif;',
                  color,
                },
              },
            ],
          });
        });
        return result;
      })
      .catch((error) => {
        console.error('axios.catch: ', error);
        return null;
      }),
  sendToGA(eventLabelName, eventAction) {
    const event = {
      eventName: 'ttcentre',
      eventCategory: 'interaction',
      eventAction: eventAction || 'digital content',
      eventLabel: eventLabelName,
      type: 'CustomTagEvent',
    };
    if (window.digitalData) {
      window.digitalData.newEvent(event);
      console.log('Window digitalData: ', event);
    } else {
      console.log('Window No digitalData: ', event);
    }
  },
};

export default API;
